import React, { useEffect } from 'react';
import OutlineLightButton from './OutlineLightButton';
import { useEscapeToClose } from '../../../../hooks/useEscapeToClose';
import styles from './photoSendGuidelinesModal.module.css';
import { LANDPAGE_PHOTO_GUIDELINES } from '../../landpage.constants';

interface PhotoSendGuidelinesModalProps {
  open: boolean;
  onClose: () => void;
}

const PhotoSendGuidelinesModal: React.FC<PhotoSendGuidelinesModalProps> = ({
  open,
  onClose,
}) => {
  const copy = LANDPAGE_PHOTO_GUIDELINES;

  useEscapeToClose(onClose, open);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="photo-guidelines-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="photo-guidelines-title" className={styles.title}>
          {copy.title}
        </h2>

        <p className={styles.intro}>{copy.intro}</p>

        <h3 className={styles.subtitle}>{copy.positionsTitle}</h3>
        <ul className={styles.list}>
          {copy.positions.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <h3 className={styles.subtitle}>{copy.tipsTitle}</h3>
        <ul className={styles.list}>
          {copy.tips.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <div className={styles.actions}>
          <OutlineLightButton onClick={onClose}>
            {copy.closeButton}
          </OutlineLightButton>
        </div>
      </div>
    </div>
  );
};

export default PhotoSendGuidelinesModal;
